import cx from 'classnames';
import {SearchWithCategory} from '~library/organisms/MegaNav/SearchWithCategory/SearchWithCategory';
import * as styles from './Search.module.scss';

type SearchProps = {
  hide?: boolean;
  className?: string;
  onSearchOpenClose?: (value: boolean) => void;
};

export const Search = ({hide = false, className, onSearchOpenClose}: SearchProps) => {
  return (
    <div
      className={cx(styles.meganavSearchBarWrapper, className, {
        [styles.meganavSearchBarWrapperHidden]: hide,
      })}
    >
      <SearchWithCategory
        data-qa-id="meganav-variant-search"
        isInline
        id="meganav-variant-search"
        // @ts-ignore
        onSearchOpenClose={onSearchOpenClose}
      />
    </div>
  );
};
